import { useMemo } from 'react'
import { useTelegram } from '@/shared/lib/telegram'
import { MainHeader, PageTitle } from '@/shared/ui'

/**
 * Виджет: Персональный хедер главной страницы
 * 
 * Использует унифицированные компоненты MainHeader и PageTitle.
 * Приветствие с динамическим временем суток.
 */
export function HomeHeader() {
  const { webApp } = useTelegram()
  const user = webApp?.initDataUnsafe?.user
  
  // Определяем приветствие по времени суток
  const greeting = useMemo(() => {
    const hour = new Date().getHours()
    if (hour >= 5 && hour < 12) return 'Доброе утро'
    if (hour >= 12 && hour < 17) return 'Добрый день'
    if (hour >= 17 && hour < 22) return 'Добрый вечер'
    return 'Доброй ночи'
  }, [])
  
  // Имя пользователя
  const userName = user?.first_name || 'друг'
  
  return (
    <>
      <MainHeader />
      <PageTitle 
        title={`${greeting}, ${userName}`}
        subtitle="Ваши вкусы, впечатления и любимые чаи — всегда под рукой."
        className="mt-6"
      />
    </>
  )
}
